import axios from '@/plugins/axios';
import qs from 'qs';
import utils from '@/stores/utils';

const { getStorageKey, loadFiltersFromStorage, saveFiltersToStorage } = utils;

const state = {
    agents: [],
    agents_count: 0,
    agents_filters: { limit: 20, ordering: 'agent_name' },
    agents_loading: false,
    agents_loading_errors: null,
    agents_cancel_source: null,

    default_billingaccount: null,
    default_billingaccount_loaded: false,

    synchronizing_agents: false,
    synchronizing_agents_errors: {}

};

const mutations = {
    updateAgents(state, agents) {
        state.agents = agents;
    },
    updateAgentsCount(state, count) {
        state.agents_count = count;
    },
    updateAgentsLoading(state, loading) {
        state.agents_loading = loading;
    },
    updateAgentsLoadingErrors(state, errors) {
        state.agents_loading_errors = errors;
    },
    updateAgentsFilters(state, filters) {
        state.agents_filters = filters;
        saveFiltersToStorage(getStorageKey('agents', 'default'), state.agents_filters);
    },
    updateAgentsCancelSource(state, source) {
        state.agents_cancel_source = source;
    },
    updateSynchronizingAgents(state, synchronizing) {
        state.synchronizing_agents = synchronizing;
    },
    updateSynchronizingAgentsErrors(state, errors) {
        state.synchronizing_agents_errors = errors;
    },
    updateDefaultBillingAccount(state, billingaccount) {
        state.default_billingaccount = billingaccount;
        state.default_billingaccount_loaded = true;
    }

};

const actions = {
    async fetchDefaultBillingAccount({ commit, dispatch, state }, params) {
        try {
            const response = await axios.get('/api/billingaccounts/', {
                params: { default: true },
            });
            commit('updateDefaultBillingAccount', response.data.results[0] || null);
            return response;
        } catch (xhr_error) {
            commit('updateDefaultBillingAccount', null);
            throw utils.handleError(xhr_error);
        }
    },

    async deleteCommercialAgent({ commit, dispatch, state }, params) {
        try {
            const response = await axios.delete(
                `/api/commercialagents/${params.instance.id}/`
            );
            await dispatch('fetchAgents');
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    },

    async fetchAgents({ commit, dispatch, state }, params) {
        commit('updateAgentsLoading', true);
        commit('updateAgentsLoadingErrors', null);

        if (state.agents_cancel_source) {
            state.agents_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateAgentsCancelSource', cancelSource);


        try {
            const response = await axios.get('/api/commercialagents/', {
                params: state.agents_filters,
                cancelToken: state.agents_cancel_source?.token,
            });
            commit('updateAgentsLoading', false);
            commit('updateAgents', response.data.results);
            commit('updateAgentsCount', response.data.count);
            commit('updateAgentsCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateAgentsLoading', false);
            commit('updateAgentsLoadingErrors', error.details);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
